/**
 * @description returns a difference between specified dates in days
 */
export function getDaysDifference(startDate: Date, endDate: Date): number {
  return (startDate.getTime() - endDate.getTime()) / 1000 / 60 / 60 / 24;
}
